import request from '@/utils/request_python'
import { h } from 'vue'

export function uploadPhoto(data, repo_id, aap_id, refo_id) {
  return request({
    url: '/foto/upload-image',
    params: { repo_id, aap_id, refo_id },
    method: 'post',    
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}
